import useBookingFormProps from '../pages/BookingForm/hooks/useBookingFormProps';

const useIsOverlay = (): boolean => {
    const { uiParameters } = useBookingFormProps();

    return window.top !== window || uiParameters?.forceOverlayMode || false;
};

export default useIsOverlay;
